@if (useCreatorShell()) {
  <a class="main-skip-link" href="#creator-main-content">Skip to main content</a>
  <app-creator-navigation></app-creator-navigation>

  <div class="creator-shell__workspace">
    <div class="creator-shell__body">
      <main id="creator-main-content" class="creator-shell__content" tabindex="-1">
        <router-outlet></router-outlet>
      </main>
    </div>
  </div>
} @else {
  <a class="main-skip-link" href="#immersive-main-content">Skip to main content</a>

  <div
    class="app-layout"
    [class.app-layout--immersive]="isImmersiveBuilderRoute()"
    [class.app-layout--quick-edit]="isImmersiveBuilderRoute()"
    [class.app-layout--editor]="isSuperEditorRoute()"
  >
    <main id="immersive-main-content" class="main-content" tabindex="-1">
      <router-outlet></router-outlet>
    </main>
  </div>
}
